import {
  ChangeDetectorRef,
  Directive,
  inject,
  Input,
  OnChanges,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { DestroyNotifierDirective } from '@shared/directives/destroy-notifier.directive';
import { UsersFacade } from '@core/users';
import { Role } from '@core/users/enums/role.enum';

@Directive({
  standalone: false,
  selector: '[hmIfRole]',
  hostDirectives: [DestroyNotifierDirective],
})
export class IfRoleDirective implements OnInit, OnChanges {
  @Input() hmIfRole!: Role | Role[];

  private isRendered = false;

  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly usersFacade = inject(UsersFacade);
  private readonly destroyNotifier = inject(DestroyNotifierDirective);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.destroyNotifier.sink = this.usersFacade.currentUser$.subscribe(() => {
      this.renderIfHasAccess();
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnChanges(): void {
    this.renderIfHasAccess();
  }

  private renderIfHasAccess() {
    const isUserAllowedToViewContent = Array.isArray(this.hmIfRole)
      ? this.hmIfRole.some((role) => this.usersFacade.checkIsUserHasRole(role))
      : this.usersFacade.checkIsUserHasRole(this.hmIfRole);

    if (isUserAllowedToViewContent && !this.isRendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.isRendered = true;
    }

    if (!isUserAllowedToViewContent && this.isRendered) {
      this.viewContainerRef.clear();
      this.isRendered = false;
    }
  }
}
